import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const SelectorEmisor = ({
    cargandoForm,
    errors,
    clearError,
    setIdEmisorSeleccionado,
    idEmisorSeleccionado,
    setRFCSeleccionado
}) => {
    const [emisores, setEmisores] = useState([]);
    
    const [cargandoEmisores, setCargandoEmisores] = useState(false);
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    useEffect(() => {
        obtenerEmisores();
    }, []);

    /**
     * Obtiene la lista de emisores disponibles
     */
    const obtenerEmisores = async () => {
        setCargandoEmisores(true);

        try {
            const response = await fetch("/api/Facturas/ObtenerEmisores", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    var ObjDetalles = JSON.parse(data.detalles);
                    setEmisores(ObjDetalles.table2 || []);

                    // Si solo hay un emisor, seleccionarlo automáticamente
                    if (ObjDetalles.table2 && ObjDetalles.table2.length === 1) {
                        const unicoEmisor = ObjDetalles.table2[0];
                        setIdEmisorSeleccionado(unicoEmisor.idDatoFiscal);
                        setRFCSeleccionado(unicoEmisor.vRFC);
                    }
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Error al obtener emisores: ' + error.message);
        } finally {
            setCargandoEmisores(false);
        }
    };

    const handleEmisorChange = (e) => {
        const idEmisor = e.target.value;
        setIdEmisorSeleccionado(idEmisor);
        if (idEmisor) {
            clearError("idEmisor");
            const selectedEmisor = emisores.find(emisor => emisor.idDatoFiscal == idEmisor);
            if (selectedEmisor) {
                setRFCSeleccionado(selectedEmisor.vRFC);
            }
        } else {
            setRFCSeleccionado("");
        }
    };

    if (cargandoForm || cargandoEmisores) {
        return <Skeleton height={38} />;
    }

    return (
        <Form.Group className="mb-3">
            <Form.Label>
                Emisor <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
                size="sm"
                value={idEmisorSeleccionado || ""}
                onChange={handleEmisorChange}
                isInvalid={!!errors.idEmisor}
                disabled={cargandoEmisores}
            >
                <option value="">Seleccione un emisor</option>
                {emisores.map((emisor) => (
                    <option key={emisor.idDatoFiscal} value={emisor.idDatoFiscal}>
                        {emisor.vRazonSocial} ({emisor.vRFC})
                    </option>
                ))}
            </Form.Select>
            {errors.idEmisor && (
                <Form.Text className="text-danger">{errors.idEmisor}</Form.Text>
            )}
            {emisores.length === 0 && !cargandoEmisores && (
                <Form.Text className="text-warning">
                    No hay emisores disponibles. Contacte al administrador.
                </Form.Text>
            )}
        </Form.Group>
    );
};

SelectorEmisor.propTypes = {
    idEmisorSeleccionado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setIdEmisorSeleccionado: PropTypes.func.isRequired,
    setRFCSeleccionado: PropTypes.func.isRequired,
    cargandoForm: PropTypes.bool,
    errors: PropTypes.object,
    clearError: PropTypes.func.isRequired,

};

export default SelectorEmisor;
